export type IntegrationInboundConfigPatch = {
  selected_stage_slug?: string | null;
  auto_assign_member_ids?: string[] | null;
};

export function parseIntegrationAutoAssignMemberIds(
  config: Record<string, unknown> | null | undefined,
): string[] {
  const raw = config?.auto_assign_member_ids;
  if (!Array.isArray(raw)) return [];
  return raw.filter((x): x is string => typeof x === "string" && x.length > 0);
}

export function parseIntegrationSelectedStageSlug(
  config: Record<string, unknown> | null | undefined,
): string | null {
  const slug = config?.selected_stage_slug;
  return typeof slug === "string" && slug.length > 0 ? slug : null;
}
